import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type CanPrintClaimType = string | string[];
export type CanPrintClaimArgs = {};

export const ruleCanPrint: SecurityRuleFactory<CanPrintClaimType, CanPrintClaimArgs> =
  createSimpleClaimRule<CanPrintClaimType, CanPrintClaimArgs>("print");

